import React from "react";
import { Layout, LARTokenHistory } from "../components";

const LARTokenHistoryPage = () => {
  return (
    <>
      <Layout>
        <LARTokenHistory />
      </Layout>
    </>
  );
};

export default LARTokenHistoryPage;
